<paginator
  [tableExporter]="exporter"
  [hidden]="!pagination"
  [paginate]="pagination"
  class="mt-3"
  #customPaginator
  (emitter)="updateData()"
>
</paginator>

<div
  class="d-flex justify-content-between align-items-center mb-3"
  *ngIf="showAddButton || showReset || selectionMode"
>
  <div class="d-flex">
    <button
      mat-raised-button
      color="primary"
      *ngIf="showAddButton"
      (click)="onAddClick()"
      class="mr-2"
    >
      {{ addButtonText }}
      <mat-icon>{{ addButtonIcon }}</mat-icon>
    </button>

    <button
      mat-raised-button
      color="warn"
      *ngIf="selectionMode"
      (click)="selectedRow(null)"
    >
      Reset
      <mat-icon>refresh</mat-icon>
    </button>
  </div>
</div>

<div
  *ngIf="models as loadedModels; else spinner"
  class="make-table-scrollable-on-mobile table-selection-container"
  [class.drag-select-active]="dragSelection.active"
  #tableContainer
  (mousedown)="onTableMouseDown($event)"
>
  <mat-spinner class="my-4" *ngIf="loading"></mat-spinner>

  <form [formGroup]="form">
    <table
      matTableExporter
      #exporter="matTableExporter"
      mat-table
      [dataSource]="loadedModels"
      matSort
      (matSortChange)="applySort($event)"
    >
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
          >
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
          >
          </mat-checkbox>
        </td>
      </ng-container>
      <ng-container *ngFor="let column of columnDefinitions">
        <ng-container
          [matColumnDef]="column.internalName"
          [ngSwitch]="column.type"
        >
          <th
            class="column-header"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            [disabled]="column.sortDisabled"
          >
            {{ column.humanName }}

            <mat-checkbox
              (click)="$event.stopPropagation()"
              *ngIf="allowHidingColumns"
              class="column-toggler-checkbox mx-2 mt-2"
              [formControlName]="column.internalName"
            >
            </mat-checkbox>
          </th>
          <ng-container *ngSwitchCase="'string'">
            <td mat-cell *matCellDef="let model">
              <ng-container *ngIf="column.inlineEdit; else plainString">
                <div
                  class="inline-edit-container no-drag-select"
                  [class.inline-edit-container--saving]="
                    isInlineSaving(model, column)
                  "
                >
                  <ng-container
                    *ngIf="isInlineEditing(model, column); else inlineDisplay"
                  >
                    <input
                      matInput
                      class="inline-edit-input"
                      [attr.maxlength]="column.inlineEdit?.maxLength || null"
                      [placeholder]="column.inlineEdit?.placeholder || ''"
                      [value]="getInlineValue(model, column)"
                      [disabled]="isInlineSaving(model, column)"
                      [attr.data-inline-key]="getInlineKey(model, column)"
                      (input)="
                        onInlineInput($event.target.value, model, column)
                      "
                      (blur)="onInlineBlur(model, column)"
                      (keydown.enter)="onInlineEnter($event, model, column)"
                      (keydown.escape)="onInlineEscape($event, model, column)"
                    />
                  </ng-container>
                  <ng-template #inlineDisplay>
                    <span
                      class="inline-edit-display"
                      (click)="startInlineEdit(model, column)"
                    >
                      {{ column.displayFunction(model) }}
                    </span>
                  </ng-template>
                  <div
                    class="inline-edit-error"
                    *ngIf="getInlineError(model, column)"
                  >
                    {{ getInlineError(model, column) }}
                  </div>
                </div>
              </ng-container>
              <ng-template #plainString>
                {{ column.displayFunction(model) }}
              </ng-template>
            </td>
          </ng-container>
          <ng-container *ngSwitchCase="'currency'">
            <td mat-cell *matCellDef="let model">
              {{ column.displayFunction(model) | currency }}
            </td>
          </ng-container>
          <ng-container *ngSwitchCase="'boolean'">
            <td mat-cell *matCellDef="let model">
              <button
                *ngIf="column.onClick"
                mat-icon-button
                (click)="onBooleanClick($event, column, model)"
                matTooltip="Cambia stato"
              >
                <mat-icon
                  [color]="
                    column.displayFunction(model) ? 'primary' : undefined
                  "
                >
                  {{
                    column.displayFunction(model) ? "done" : "not_interested"
                  }}
                </mat-icon>
              </button>
              <mat-icon *ngIf="!column.onClick">
                {{ column.displayFunction(model) ? "done" : "not_interested" }}
              </mat-icon>
            </td>
          </ng-container>
          <ng-container *ngSwitchCase="'button'">
            <td mat-cell *matCellDef="let model">
              <button mat-icon-button (click)="column.onClick(model)">
                <mat-icon>{{ column.internalName }}</mat-icon>
              </button>
            </td>
          </ng-container>
          <ng-container *ngSwitchCase="'date'">
            <td mat-cell *matCellDef="let model">
              {{ column.displayFunction(model) }}
            </td>
          </ng-container>
          <ng-container *ngSwitchCase="'datetime'">
            <td mat-cell *matCellDef="let model">
              {{ column.displayFunction(model) }}
            </td>
          </ng-container>
          <ng-container *ngSwitchCase="'datetimefromnow'">
            <td mat-cell *matCellDef="let model">
              {{ column.displayFunction(model) }}
            </td>
          </ng-container>
          <ng-container *ngSwitchCase="'link'">
            <td mat-cell *matCellDef="let model">
              <ng-container *ngIf="column.hoverPreview; else simpleLink">
                <span
                  class="link-with-preview"
                  (mouseenter)="onPreviewEnter($event, model, column)"
                  (mousemove)="onPreviewMove($event, model, column)"
                  (mouseleave)="onPreviewLeave(model, column)"
                >
                  <a [routerLink]="column.href(model)">
                    {{ column.displayFunction(model) }}
                  </a>
                  <div
                    class="preview-container"
                    *ngIf="isPreviewVisible(model, column)"
                    [ngStyle]="getPreviewStyles(model, column)"
                  >
                    <ng-container [ngSwitch]="getPreviewKind(model, column)">
                      <img
                        *ngSwitchCase="'image'"
                        [src]="getPreviewUrl(model, column)"
                        alt="Anteprima file"
                      />
                      <iframe
                        *ngSwitchCase="'pdf'"
                        [src]="getPdfPreviewUrl(model, column)"
                        title="Anteprima PDF"
                        frameborder="0"
                      ></iframe>
                      <span *ngSwitchDefault>Anteprima non disponibile</span>
                    </ng-container>
                  </div>
                </span>
              </ng-container>
              <ng-template #simpleLink>
                <a [routerLink]="column.href(model)">
                  {{ column.displayFunction(model) }}
                </a>
              </ng-template>
            </td>
          </ng-container>
          <ng-container *ngSwitchCase="'percentage'">
            <td mat-cell *matCellDef="let model">
              {{ column.displayFunction(model) || 0 }}%
            </td>
          </ng-container>
          <ng-container *ngSwitchCase="'image'">
            <td style="text-align: center" mat-cell *matCellDef="let model">
              <img
                style="height: 25px"
                *ngIf="column.displayFunction(model)"
                [src]="column.displayFunction(model)"
              />
            </td>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
          Azioni

          <ng-container *ngIf="allowHidingColumns">
            <button
              mat-icon-button
              matTooltip="Mostra / Nascondi colonne della tabella"
              [matMenuTriggerFor]="hideColumnsMenu"
            >
              <mat-icon> arrow_drop_down </mat-icon>
            </button>
            <mat-menu #hideColumnsMenu="matMenu">
              <button
                mat-menu-item
                *ngFor="let column of columnDefinitions"
                (click)="toggleVal(column)"
              >
                <div class="row">
                  <span class="col-9">{{ column.humanName }}</span>
                  <span class="col-3 text-right">
                    <mat-checkbox [formControlName]="column.internalName">
                    </mat-checkbox>
                  </span>
                </div>
              </button>
            </mat-menu>
          </ng-container>
        </th>
        <td mat-cell *matCellDef="let model">
          <button
            *ngIf="previewFunction"
            title="Apri in split view"
            mat-icon-button
            (click)="previewFunction(model)"
          >
            <mat-icon>visibility</mat-icon>
          </button>

          <button
            *ngIf="editFunction"
            title="Modifica Anagrafica"
            mat-icon-button
            (click)="editFunction(model)"
          >
            <mat-icon>edit</mat-icon>
          </button>

          <button
            *ngIf="notShowDelete && deleteFunction"
            [disabled]="!canDeleteModels(loggedInUser)"
            title="Elimina"
            mat-icon-button
            (click)="deleteFunction(model)"
          >
            <mat-icon>delete</mat-icon>
          </button>

          <button
            *ngIf="downloadFunction"
            title="Download file"
            mat-icon-button
            (click)="downloadFunction(model)"
          >
            <mat-icon>download</mat-icon>
          </button>
        </td>
      </ng-container>
      <ng-container matColumnDef="selectThisRow">
        <th mat-header-cell *matHeaderCellDef>Seleziona</th>
        <td mat-cell *matCellDef="let model">
          <button
            title="Seleziona questa riga"
            mat-icon-button
            (click)="selectedRow(model)"
          >
            <mat-icon>check</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr
        mat-header-row
        *matHeaderRowDef="namesOfColumnsThatShouldBeDisplayed"
      ></tr>
      <tr
        mat-row
        *matRowDef="let myRowData; columns: namesOfColumnsThatShouldBeDisplayed"
        [ngClass]="rowClassGetter ? rowClassGetter(myRowData) : null"
      ></tr>
    </table>
  </form>
  <div
    class="selection-rectangle"
    *ngIf="dragSelection.active"
    [ngStyle]="selectionBoxStyles"
  ></div>
</div>
<ng-template #spinner>
  <mat-spinner> </mat-spinner>
</ng-template>
